import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { DialogBox } from './Styles/DeleteItemDialogBox';

import { deleteInventory } from '../../actions/inventoryActionsV2';

const DeleteItemDialogBox = ({ open, item, onTrue, onFalse, ...props }) => {
	const onTrueHandler = async () => {
		await props.deleteInventory(item);
		onTrue();
	};

	const onFalseHandler = () => {
		onFalse();
	};

	useEffect(() => {}, [open, item]);

	return (
		<DialogBox
			open={open}
			title={'Delete Inventory Item'}
			content={'Are you sure you want to delete this item?'}
			onTrue={() => {
				onTrueHandler();
			}}
			onFalse={() => {
				onFalseHandler();
			}}
		/>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {
	deleteInventory,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(DeleteItemDialogBox);
